<template>
	<div v-show="fieldList.length" class="custom-field">
		<c-field v-for="(item, i) in fieldList" :key="i" :label="item.field_title">
			<template v-if="data">
				<c-file-list v-if="['image', 'file'].includes(item.config_json.type)" :value="data[item.field_code].value"></c-file-list>
				<c-tags v-else-if="typeof data[item.field_code].value == 'object'" :value="data[item.field_code].value"></c-tags>
				<div v-else-if="item.config_json.type == 'text' && item.config_json.attr.includes('textarea')" style="max-height: 65px; overflow: auto; white-space: pre-wrap;">{{data[item.field_code].value || '-'}}</div>
				<span v-else-if="item.config_json.type == 'rel_object'">{{data[item.field_code].display_value || '-'}}</span>
				<span v-else>{{data[item.field_code].value || '-'}}</span>
			</template>
		</c-field>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'customField',

		props: {
			workType: [String, Number],
			data: Object
		},

		computed: {
			...mapState(['customField']),

			fieldList() {
				return this.customField[this.workType] || [];
			}
		},

		mounted() {
			this.$store.dispatch('updateFieldConfig');
		}
	}
</script>

<style lang="stylus" scoped>
</style>
